import React from 'react';
import { StateProvider } from './store/MainContext';
import './assets/css/global.css';
import './assets/css/style.css';
import RTL from './RTL';
import { SnackbarProvider } from 'notistack';
import Routes from './views/';
import CacheBuster from './CacheBuster';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RTL>
        <SnackbarProvider maxSnack={3}>
          <StateProvider>
            <CacheBuster>
              <Routes />
            </CacheBuster>
          </StateProvider>
        </SnackbarProvider>
      </RTL>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
export default App;
